import { useContext, useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import images from 'assets/Images.js';
import OverviewContext from 'store/overview-context';
import { langOptions } from 'config/config';
import styles from './Header.module.scss';

const Header = () => {
	const overviewContext = useContext(OverviewContext);
	const [displayLang, setDisplayLang] = useState(false);
	const langRef = useRef(null);

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
	}, [])

	const handleClickOutside = e => {
		if (!langRef?.current?.contains(e?.target)) setDisplayLang(false);
	}

	const redirectToHome = () => {
		overviewContext.reset();
	};

	const getLang = key => {
		return overviewContext?.langObj?.content?.[key] || '';
	};

	const navigation = overviewContext.tabValue !== 'home' && (
		<>
			<span>&#8250;</span>
			<h4>{getLang(overviewContext?.tabValue)}</h4>
		</>
	);

	const handleInputs = data => {
		setDisplayLang(s => !s);
		overviewContext?.setSelectedLang(data);
		overviewContext?.setLangObj(langOptions?.find(lang => lang?.key === data));
	};

	const language = overviewContext?.preferredLang?.length > 1 && (
		<div ref={langRef}>
			<div className={styles.header__langContent} onClick={() => setDisplayLang(s => !s)}>
				<p>{overviewContext?.preferredLang ? overviewContext?.preferredLang?.find(lang => lang?.key == overviewContext?.selectedLang)?.value : ''}</p>
				<img className={styles.header__lang} src={images.downArrow} alt='down' />
			</div>
			{displayLang && (
				<ul className={styles.header__langDropdown}>
					{overviewContext?.preferredLang?.map((lang, i) => (
						<li key={i} className={overviewContext?.selectedLang === lang?.key ? styles.header__dropdownSelected : styles.header__dropdown} onClick={() => handleInputs(lang?.key)}>
							{lang?.value}
						</li>
					))}
				</ul>
			)}
		</div>
	);

	return (
		<div className={styles.header}>
			<div className={styles.header__title}>
				<Link to={{ pathname: '/overview', search: overviewContext.searchURL }}>
					<img src={images.homeImg} onClick={redirectToHome} alt='home' />
					{overviewContext.tabValue === 'home' && (
						<h4 className={styles.header__client} onClick={redirectToHome}>
							{overviewContext?.overviewData?.clientName}
						</h4>
					)}
				</Link>
				{navigation}
			</div>
			{language}
		</div>
	);
};

export default Header;
